module.exports = __webpack_public_path__ + "img/bg_corner02.cd3a25a6.svg";